import reducer from './reducer';
import { MODULE_NAME, ROUTE_TYPES_BY_VALUE, ROUTE_TYPES_VALUES, TABLE_SESSION_TYPE } from './constants';

export {
    initializeRestaurant,
    initializeCode,
    showInfo,
    hideInfo,
    readInfo,
    sendCallWaiter,
    waiterCalled,
    fetchLastBill,
    publishNewMenu,
    clearPublishNewMenu
} from './actions';

export {
    selectRestaurantInfoVisibility,
    selectIsInitalized,
    selectRestaurantData,
    selectRestaurantSlug,
    selectIsRestaurantLoaded,
    selectRestaurantBackground,
    selectRestaurantBackgroundSrcSet,
    selectRestaurantLogo,
    selectRestaurantLogoSrcSet,
    selectRestaurant,
    selectCallWaiterNotification,
    selectWaiterCalledError,
    selectRestaurantGallery,
    selectTableNameAndNumber,
    selectRestaurantName,
    selectIsInfoRead,
    selectRestaurantColors,
    selectCode,
    selectRestaurantSchedule,
    selectLastBill,
    selectLastOrders,
    selectLastBillOrders,
    selectLastBillSummary,
    selectRouteType,
    selectRestaurantTableSessionType,
    selectIsNewMenuPublished,
    selectPublishNewMenuError,
    selectRestaurantDescription
} from './selectors';

export {
    ROUTE_TYPES_BY_VALUE,
    ROUTE_TYPES_VALUES,
    TABLE_SESSION_TYPE
};

export default {
    reducer,
    moduleName: MODULE_NAME
};
